import { Button, Card, Col, Modal, Row, Typography } from "antd";
import axios from "axios";
import { message } from "@bindeleddet/core/utils";
import { useEffect, useState } from "react";

const { Title, Text } = Typography;

interface StudyProgramApplication {
  id: number;
  student_id: number;
  student_name: string;
  study_programme_id: number;
  study_programme_name: string;
  past_study_program_id: number;
  past_study_programme_name: string;
  year_level: number;
  past_year_level: number;
  screenshot: string;
  active: boolean;
  created_at: string;
}

const StudyProgramApplications = () => {
  const [applications, setApplications] = useState<StudyProgramApplication[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchApplications = async () => {
    setLoading(true);
    try {
      const response = await axios.get<StudyProgramApplication[]>("/students/study-program-applications/");
      setApplications(response.data.filter(app => app.active));
    } catch (error) {
      message("error", "Kunne ikke hente søknader");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  const handleViewDocumentation = (screenshot: string) => {
    // Open in new tab
    window.open(screenshot, "_blank");
  };

  const handleApprove = async (applicationId: number) => {
    Modal.confirm({
      title: "Sikker på at du vil godkjenne søknaden?",
      content: "Studentens linje og årskull vil bli oppdatert, og studenten vil få e-post om godkjenningen.",
      okText: "Bekreft",
      cancelText: "Avbryt",
      okType: "primary",
      onOk: async () => {
        try {
          await axios.post(`/students/study-program-applications/${applicationId}/approve/`);
          message("success", "Søknad godkjent", "Studenten har fått e-post om godkjenningen");
          fetchApplications();
        } catch (error) {
          message("error", "Kunne ikke godkjenne søknad");
        }
      },
    });
  };

  const handleReject = async (applicationId: number) => {
    Modal.confirm({
      title: "Sikker på at du vil avslå søknaden?",
      content: "Studenten vil få e-post om avslaget og søknaden vil bli slettet.",
      okText: "Avslå",
      cancelText: "Avbryt",
      okType: "danger",
      onOk: async () => {
        try {
          await axios.post(`/students/study-program-applications/${applicationId}/reject/`);
          message("success", "Søknad avslått", "Studenten har fått e-post om avslaget");
          fetchApplications();
        } catch (error) {
          message("error", "Kunne ikke avslå søknad");
        }
      },
    });
  };

  return (
    <Card style={{ width: "100%" }}>
      <Title level={2}>Søknader om linjebytte</Title>
      {loading ? (
        <Text>Laster...</Text>
      ) : applications.length === 0 ? (
        <Text>Ingen aktive søknader</Text>
      ) : (
        <Row gutter={[16, 16]}>
          {applications.map(application => {
            return (
              <Col xs={24} sm={24} md={12} lg={8} key={application.id}>
                <Card title={<Text strong>{application.student_name}</Text>} style={{ marginBottom: 16 }}>
                  <Text>
                    <strong>Søker om å bytte fra:</strong> {application.past_study_programme_name}{" "}
                    {application.past_year_level}. klasse
                  </Text>
                  <br />
                  <Text>
                    <strong>Til:</strong> {application.study_programme_name} {application.year_level}. klasse
                  </Text>
                  <br />
                  <br />
                  <Row gutter={[8, 8]}>
                    <Col span={24}>
                      <Button block onClick={() => handleViewDocumentation(application.screenshot)}>
                        Vis dokumentasjon
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button block type="primary" onClick={() => handleApprove(application.id)}>
                        Bekreft
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button block danger onClick={() => handleReject(application.id)}>
                        Avslå
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
            );
          })}
        </Row>
      )}
    </Card>
  );
};

export default StudyProgramApplications;
